import { atom } from 'jotai';

/**
 * UI state for the Remote status card (APP-7873). `dismissedKey` stores the
 * dismissed card-instance key (derived from the hold's `anchorMs` / recovered
 * recording), so a NEW offline window self-resets a stale dismissal.
 */
export interface ChronicleRemoteStatusCardState {
  isExpanded: boolean;
  dismissedKey: string | null;
}

export const chronicleRemoteStatusCardAtom = atom<ChronicleRemoteStatusCardState>({
  isExpanded: false,
  dismissedKey: null,
});
